<template>
  <div id="telaPrincipal">
    <div v-if="!exibirNovaConfissao">
      <div class="mb-5 px-md-2 w-md-80" style="margin-top: 4%; margin-left: 1%">
        <h5 class="text-justify titulo">
          <strong>CONFISSÃO ESPONTÂNEA DE DÉBITOS ISSQN</strong>
        </h5>
      </div>

      <h3 class="text-center mt-5">PRINCIPAIS SERVIÇOS OFERECIDOS</h3>
      <div class="d-flex justify-content-center container-fluid row mb-3"
        style="height: calc(100vh - 600px); align-items: center">
        <botaoTelaInicial titulo="NOVA CONFISSÃO" descricao="Inclui novos débitos ISSQN"
          textoAlternativo="Nova Confissão" :loginRequired="true" :funcao="seguirParaConfissao"
          :image="$baseUrl('icons/CERTIFICATE.svg')" />
        <botaoTelaInicial titulo="REEMITIR GUIAS" descricao="Emite guias de confissões em aberto"
          textoAlternativo="Nova Confissão" link="reemisao_guia_parc_expon" :funcao="goToReemitirGuias"
          :image="$baseUrl('icons/CERTIFICATE.svg')" />
        <botaoTelaInicial titulo="REEMITIR TERMO DE CONFISSÃO" descricao="Pesquisar por Termos de Confissão"
          textoAlternativo="Nova Confissão" link="reemitir_termo_confissao" :funcao="() => { }"
          :image="$baseUrl('icons/NOTE.svg')" />
      </div>
    </div>
    <div class="container my-2" v-if="exibirNovaConfissao">
      <div v-if="mensagemSucesso">
        <div v-for="i in mensagemSucesso" :key="i">
          <b-alert show variant="success" dismissible>
            <b-icon variant="success" icon="check" />
            {{ i }}
          </b-alert>
        </div>
      </div>

      <div v-if="mensagemErro">
        <div v-for="i in mensagemErro" :key="i">
          <b-alert show variant="danger" dismissible>
            <b-icon variant="danger" icon="x-circle-fill" />
            {{ i }}
          </b-alert>
        </div>
      </div>

      <div v-if="
        tipoISSQN === '1443' && tipoISSQN === '1575' && seguirParaReferencias
      ">
        <div>
          <b-alert show variant="warning">
            <b-icon variant="warning" icon="exclamation-diamond-fill" />
            {{ mensagemISSQNFonte }}
          </b-alert>
        </div>
      </div>

      <div style="text-align: center">
        <loading :active.sync="carregando" :is-full-page="true"></loading>
      </div>

      <form @submit.prevent>
        <h2 class="title">Selecionar Inscrição</h2>
        <!-- COMEÇA -->
        <div v-if="logadoGovBr">
          <b-card>
            <b-row class="mb-3">
              <b-col sm="2" align-self="end">
                <label for="CPFContribuinte">CPF</label>
              </b-col>
              <b-col sm="2" align-self="start">
                <b-form-input id="CPFContribuinte" disabled v-model="contribuinte.cpf">
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="2" align-self="end">
                <label for="NomeContribuinte">Nome</label>
              </b-col>
              <b-col sm="6" align-self="start">
                <b-form-input id="NomeContribuinte" disabled v-model="contribuinte.nome">
                </b-form-input>
              </b-col>
            </b-row>

            <div v-if="cnpj.nome && cnpj.valor">
              <b-row class="mb-3">
                <b-col sm="2" align-self="end">
                  <label for="CNPJEmpresa">CNPJ</label>
                </b-col>
                <b-col sm="3" align-self="start">
                  <b-form-input id="CNPJEmpresa" disabled v-model="cnpj.valor">
                  </b-form-input>
                </b-col>
              </b-row>

              <b-row class="mb-3">
                <b-col sm="2" align-self="end">
                  <label for="NomeFantasia">Nome Fantasia</label>
                </b-col>
                <b-col sm="6" align-self="start">
                  <b-form-input id="NomeFantasia" disabled v-model="cnpj.nome">
                  </b-form-input>
                </b-col>
              </b-row>

              <div v-if="contribuinte.inscricaoMunicipal && seguirParaSelecaoISSQN">
                <b-row class="mb-3">
                  <b-col sm="2" align-self="end">
                    <label for="InscricaoMunicipal">Inscrição Municipal</label>
                  </b-col>
                  <b-col sm="2" align-self="start">
                    <b-form-input id="InscricaoMunicipal" disabled v-model="contribuinte.inscricaoMunicipal">
                    </b-form-input>
                  </b-col>
                </b-row>
              </div>
            </div>

            <tabelaListagemCNPJ v-if="mostrarListagemCnpj" :rows="cnpjsRelacionadosTabela"
              :forca-limpar-campos="forcaLimparCamposListagemCnpj" @update:selecionado="handleCnpjTabelaSelecionado" />

            <b-row class="float-right mt-3 mr-3">
              <b-col v-if="!mostrarListagemCnpj">
                <b-button variant="outline-secondary" @click="limpar">Pesquisar novamente</b-button>
              </b-col>
              <b-col sm="5" v-if="mostrarListagemCnpj">
                <b-button variant="primary" @click="pesquisar" :disabled="desabilitarPesquisar || listaInscricaoMunicipal.length > 0
                  ">Pesquisar</b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>
        <div v-else>
          <div class="ml-2" v-if="exibeInformarCNPJ">
            <b-card class="mb-5" style="width: 70%">
              <span class="title h5" v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Pesquisar empresas ligadas ao CPF.">
                Dados do contribuinte
                <b-icon variant="primary" icon="info-circle-fill" class="ml-2" />
              </span>

              <b-row class="mb-3 mt-4">
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="3" md="3" clas="ml-2" lg="1" align-self="center">
                  <label for="cpf" class="pb-3">CNPJ</label>
                </b-col>
                <b-col sm="8" md="4" class="ml-4" align-self="start">
                  <b-form-input id="cpfCnpj" 
                     style="text-transform: uppercase"
                     class="ml-3" v-mask="['XX.XXX.XXX/XXXX-##']" 
                     v-model="CNPJinformado"
                     @keyup="validacaoCNPJ()">
                  </b-form-input>
                  <small id="cpfCnpj" :class="erroValidacaoCNPJ" class="ml-3 form-text">
                    {{ mensagemValidacaoCNPJ }}
                  </small>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col sm="0" md="0"> </b-col>
                <b-col sm="1" md="1"> </b-col>
                <b-col sm="0" align-self="end" style="padding-rigth=0px">
                  <label for="NomeFantasia">Nome Fantasia</label>
                </b-col>
                <b-col sm="8" style="padding-left=0px" align-self="start">
                  <b-form-input id="NomeFantasia" disabled v-model="cnpj.nome">
                  </b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-1 mt-3 float-right">
                <b-col sm="4" class="mr-3">
                  <b-button variant="outline-secondary" @click="limparCNPJ">
                    Limpar
                  </b-button>
                </b-col>
                <b-col sm="7">
                  <b-button variant="primary" :disabled="!preencheCnpjOK" @click="pesquisar">
                    Pesquisar
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </div>
        <!-- TERMINA -->
        <div v-if="listaInscricaoMunicipal.length > 0 && !seguirParaSelecaoISSQN">
          <h2 class="title">Inscrição Municipal</h2>
          <b-card class="mt-3">
            <b-row>
              <b-col align-self="end">
                <label class="h6">Selecione uma inscrição municipal</label>
              </b-col>
            </b-row>
            <b-row class="my-2 ml-4">
              <b-row class="mt-2 mb-2 mt-0" v-for="(inscricaoMunicipal, index) in listaInscricaoMunicipal" :key="index">
                <b-col>
                  <b-form-checkbox sm="4" align-self="end" v-model="contribuinte.inscricaoMunicipal"
                    :value="inscricaoMunicipal.value">
                    <span class="font-weight-bold">{{ inscricaoMunicipal.text }}
                    </span>
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-row>

            <b-row class="float-right mt-3 mr-3">
              <b-col>
                <b-button variant="primary" @click="seguirSelecaoISSQN"
                  :disabled="!contribuinte.inscricaoMunicipal">Selecionar</b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <div v-if="seguirParaSelecaoISSQN && !seguirParaReferencias">
          <h2 class="title">Tributo</h2>
          <b-card class="mt-3">
            <b-row>
              <b-col align-self="end">
                <label class="h6">Selecione o tipo de ISSQN</label>
              </b-col>
            </b-row>

            <b-row class="my-2 ml-4" v-for="(issqn, index) in tiposISSQN" :key="index">
              <b-row>
                <b-col>
                  <b-form-checkbox sm="4" align-self="end" v-model="issqnSelecionado" :value="issqn">
                    <span class="font-weight-bold">{{ issqn.text }} </span>
                  </b-form-checkbox>                  
                </b-col>
              </b-row>
            </b-row>

            <b-row class="float-right mt-3">
              <b-col>
                <b-button variant="primary" @click="seguirParaReferencias = !seguirParaReferencias"
                  :disabled="!tipoISSQN">Selecionar</b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <div v-if="
          tipoISSQN &&
          seguirParaReferencias &&
          !seguirParaSumario &&
          !mostrarReferenciaESimulacoes
        ">
          <h2 class="title">Valores confessados</h2>
          <b-card class="mt-3">
            <div v-if="descTipoISSQN">
              <b-row class="mb-3">
                <b-col sm="2" align-self="end">
                  <label for="InscricaoMunicipal">Tributo selecionado</label>
                </b-col>
                <b-col sm="5" align-self="start">
                  <b-form-input id="InscricaoMunicipal" disabled v-model="descTipoISSQN">
                  </b-form-input>
                </b-col>
              </b-row>
            </div>            

            <b-row>
              <b-col v-if="
                acaoFiscalEmVigor.minima != '' &&
                acaoFiscalEmVigor.maxima != '' &&
                tipoISSQN &&
                seguirParaReferencias &&
                !seguirParaSumario &&
                !mostrarReferenciaESimulacoes
              " class="mt-2">
                <b-alert show variant="warning" v-if="this.acaoFiscalEmVigor.idTipoAcaoFiscal !== 3">
                  Atenção: Empresa sob ação fiscal no período de
                  {{ formatarDataReferencia(acaoFiscalEmVigor.minima) }} a
                  {{ formatarDataReferencia(acaoFiscalEmVigor.maxima) }}. Os
                  valores confessados neste período possuem multa majorada.
                </b-alert>
                <b-alert show variant="warning" v-else>
                  Não é possível confessar débitos para o período de
                  {{ formatarDataReferencia(acaoFiscalEmVigor.minima) }} a
                  {{ formatarDataReferencia(acaoFiscalEmVigor.maxima) }}.
                </b-alert>
                <b-alert show variant="danger" v-if="this.mostrarErroForaAcaoFiscal === true">
                  <b-icon variant="danger" icon="x-circle-fill" />
                  A data de competência inserida está fora da ação fiscal. Caso
                  necessário incluir valores neste período, favor registrar uma
                  nova Confissão.
                </b-alert>
                <b-alert show variant="danger" v-if="this.mostrarErroDentroAcaoFiscal === true">
                  <b-icon variant="danger" icon="x-circle-fill" />
                  A data de competência inserida está dentro da ação fiscal.
                  Caso necessário incluir valores neste período, favor registrar
                  uma nova Confissão.
                </b-alert>
              </b-col>
            </b-row>
            <b-row>
              <b-col align-self="end">
                <label class="h6">Preencha nos campos abaixo os valores devidos e o mês/ano de
                  referência</label>
              </b-col>
            </b-row>

            <div>
              <b-alert v-if="listaReferencias.length === 72" variant="warning">
                <b-icon variant="warning" icon="exclamation-diamond-fill" />
                O limite de referências não pode exceder 72 registros.
              </b-alert>
              <b-row class="my-2">
                <b-col sm="3" align-self="center" class="">
                  <span v-b-tooltip.hover.html="{ variant: 'primary' }" :title="stringDataReferencia">
                    <label for="referencia" class="mr-2">Competência (mês/ano)</label>
                    <b-icon variant="primary" icon="info-circle-fill" />
                  </span>

                  <b-form-input ref="referencia" id="referencia" placeholder="MM/AAAA" v-mask="'##/####'"
                    v-model="referencia.data" :class="consisteDataReferencia()" />

                  <div class="valid-feedback">Data de competência válida.</div>
                  <div class="invalid-feedback">
                    Data de competência inválida.
                  </div>
                </b-col>

                <b-col sm="4" class="ml-5 mr-1" align-self="center">
                  <span v-b-tooltip.hover.html="{ variant: 'primary' }"
                    title="Insira o valor do ISSQN devido no formato monetário.">
                    <label for="impostoDevido" class="mr-2">Imposto Devido</label>
                    <b-icon variant="primary" icon="info-circle-fill" />
                  </span>

                  <b-form-input id="impostoDevido" type="text" inputmode="numeric" v-model="impostoDevidoFormatado"
                    @keydown="bloquearExcesso" @input="formatarValor" :class="consisteImpostoDevido()" />
                  <div class="valid-feedback">Imposto devido informado.</div>
                  <div class="invalid-feedback">
                    Imposto devido não informado.
                  </div>
                </b-col>
                <b-col sm="2" class="mt-4">
                  <b-button class="mt-2 ml-5" variant="primary" @click="adicionaAcaoFiscal" :disabled="!validaReferencia ||
                    !validarImpostoDevido ||
                    listaReferencias.length > 72 ||
                    referenciaDuplicada ||
                    referenciaAtualDuplicada ||
                    somaReferenciasMaiorQueMaximo
                    ">Incluir</b-button>
                </b-col>
                <b-col sm="2" class="mt-4">
                  <b-button variant="outline-secondary" @click="limparValoresReferencias()" class="mr-2 mt-2">Limpar
                    valores</b-button>
                </b-col>
                <b-col v-if="referenciaAtualDuplicada" class="mt-2">
                  <b-alert show variant="danger">
                    <b-icon variant="danger" icon="x-circle-fill" />
                    Não é possível inserir uma mesma competência mais de uma vez
                  </b-alert>
                </b-col>
                <b-col v-if="somaReferenciasMaiorQueMaximo" class="mt-2">
                  <b-alert show variant="danger">
                    <b-icon variant="danger" icon="x-circle-fill" />
                    A soma dos valores confessados não podem ultrapassar R$
                    100.000.000,00
                  </b-alert>
                </b-col>
              </b-row>
            </div>

            <div v-if="listaReferencias.length > 0" class="mt-4">
              <b-table summary="Tabela de Referências" responsive stacked="md" :bordered="false" select-mode="multi"
                striped hover :small="true" :items="listaReferencias" :fields="cabecalhoReferencias" show-empty
                empty-text="Tente novamente mais tarde. Erro inesperado na rotina de lançamentosSelecionados."
                primary-key="id">
                <template #cell(index)="data">
                  <div class="text-center m-0 p-1" data-align="right">
                    {{ data.index + 1 }}
                  </div>
                </template>

                <template #cell(imposto)="row">
                  <div class="m-0 p-1">
                    <p class="h6">{{ row.impostoDevido }}</p>
                  </div>
                </template>

                <template #cell(acao)="row">
                  <p class="h6 m-0 p-1">
                    <b-icon v-b-tooltip.hover title="Remover" variant="danger" icon="trash-fill"
                      @click="() => removerReferencia(row.index)"></b-icon>
                  </p>
                </template>
              </b-table>

              <b-tfoot>
                <b-tr>
                  <b-td class="float-right">
                    Total: <strong>{{ formatarMoeda(retornaTotal()) }}</strong>
                  </b-td>
                </b-tr>
              </b-tfoot>
            </div>

            <b-row class="float-right mt-3">
              <b-col>
                <b-button variant="primary" @click="atualizaReferencia" :disabled="listaReferencias.length === 0 || referenciaDuplicada
                  ">Calcular Valores</b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <div v-if="mostraTotaisEOpcoesPagamentos">
          <h2 class="title">Resumo dos valores totais e forma de pagamento</h2>
          <b-card class="mt-3">
            <b-table summary="Resumo dos valores totais e forma de pagamento" responsive stacked="md" :bordered="false"
              select-mode="multi" striped hover :small="true" :items="valorFormatado" :fields="cabecalhoSumario"
              show-empty empty-text="Tente novamente mais tarde. Erro inesperado na rotina de lançamentosSelecionados."
              primary-key="id">
              <template #cell(acoes)>
                <b-button variant="outline-success" @click="$bvModal.show('modal-detalhe-valores-referencia')">Exibir
                  detalhes</b-button>
              </template>
            </b-table>
            <div class="float-right mb-3">
              <b-button variant="outline-secondary" class="mr-3" @click="mostrarTabelaReferencias">Alterar
                Referências</b-button>
            </div>
          </b-card>
        </div>

        <div v-if="
          mostrarReferenciaESimulacoes &&
          !ocultarReferenciasESimulacoes &&
          !seguirParafinal
        ">
          <h2 class="title">Seleção de Referências</h2>
          <b-card class="mt-3">
            <b-row class="text-center">
              <b-col><b-button @click="$bvModal.show('modal-detalhe-valores-referencia')" variant="link">Ver Referências
                  Listadas</b-button></b-col>
              <b-col><b-button @click="mostrarTabelaReferencias" variant="link">Incluir Novas
                  Referências</b-button></b-col>
            </b-row>
          </b-card>
        </div>
        <div v-if="mostraTotaisEOpcoesPagamentos">
          <h2 class="title">Selecione a forma de pagamento</h2>
          <div>
            <div v-if="tipoISSQN === '1443'">
              <b-alert show variant="warning">
                <b-icon variant="warning" icon="exclamation-diamond-fill" />
                <!-- {{ mensagemISSQNFonte }} -->
                Atenção: O parcelamento do ISSQN-Fonte Não Retido é restrito às
                hipóteses descritas no Art. 21, Lei Municipal nº 8.725/2003.
              </b-alert>          
            </div>
            <div v-if="tipoISSQN === '1480'">
              <b-alert show variant="warning">
                <b-icon variant="warning" icon="exclamation-diamond-fill" />
                Atenção: O parcelamento de ISSQN-Fonte Retido não inscrito em
                Dívida Ativa é vedado por lei, nos termos do art. 2º, p.u., I da
                Lei Municipal nº 10.082/2011.
              </b-alert>               
            </div>
          </div>
          <b-card class="mt-3">
            <b-row class="text-center">             
              <b-col>
                <b-button @click="SeguirParaFormaPagamento('AVISTA')" variant="primary">Pagar à Vista</b-button>
              </b-col>             
              <b-col>
                <b-button :disabled="tipoISSQN === '1480'" @click="
                  SeguirParaFormaPagamento('PARCELAR');
                simularOutrasFormasPagamento(
                  valorSumario[0].valorTotalParcelamento
                );
                " variant="primary">
                  Parcelar
                </b-button>
              </b-col>
              <b-col>
                <b-button :disabled="tipoISSQN === '1480'" @click="
                  SeguirParaFormaPagamento('DEBITOAUTOMATICO');
                simularOutrasFormasPagamento(
                  valorSumario[0].valorTotalDebitoAutomatico
                );
                " variant="primary">
                  Parcelar com Débito Automático
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <div v-if="seguirParaSumarioAVista">
          <h2 class="title">Pagamento à vista</h2>
          <b-card class="mt-3">
            <b-table summary="Resumo do valor de pagamento à vista" responsive stacked="md" :bordered="false"
              select-mode="multi" striped hover :small="true" :items="valorFormatado" :fields="cabecalhoSumarioAVista"
              show-empty empty-text="Tente novamente mais tarde. Erro inesperado na rotina de lançamentosSelecionados."
              primary-key="id">
            </b-table>
            <div class="float-right mb-3">
              <b-button variant="primary" @click="$bvModal.show('modal-confirmar-confissao-a-vista')">Confirmar
                Confissão à
                Vista</b-button>
            </div>
            <b-modal id="modal-confirmar-confissao-a-vista" hide-footer modal-class="small-modal"
              title="Confirma a confissão de débitos?" centered no-close-on-backdrop>
              <p>
                <b-icon icon="exclamation-triangle-fill" scale="1" variant="warning" class="mr-2"></b-icon>
                O método de pagamento selecionado foi o pagamento
                <strong>à vista</strong>. Após a confirmação, o lançamento
                estará constituído e <strong>não poderá ser alterado</strong>.
              </p>
              <b-button-group class="w-100">
                <b-button variant="outline-secondary" class="mr-3"
                  @click="$bvModal.hide('modal-confirmar-confissao-a-vista')">NÃO</b-button>
                <b-button variant="primary" @click="aoConfirmarModalAVista">SIM</b-button>
              </b-button-group>
            </b-modal>
          </b-card>
        </div>
        <div v-if="seguirParaFinalAVista">
          <h2 class="title">Emissão Guia para Pagamento à vista</h2>
          <b-card class="mt-3" id="finalDebitoAutomatico">
            <table summary="Tabela de Emissão Guia" class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Descrição</th>
                  <th>Número do guia</th>
                  <th>Vencimento</th>
                  <th>Valor total</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Guia de débitos PBH vencimento em
                    {{ guiaEmitida.dataVencimento }}
                  </td>
                  <td>{{ guiaEmitida.numeroGuia }}</td>
                  <td>{{ guiaEmitida.dataVencimento }}</td>
                  <td>{{ formatarMoeda(guiaEmitida.valorTotal) }}</td>
                  <td class="row p-0 m-0 border-0">
                    <div class="col-6">
                      <b-button v-if="guiaEmitida" variant="primary" @click="emitirDRAM">
                        Emitir DRAM
                      </b-button>
                      <span v-else class="badge bg-danger text-white">DRAM emitida</span>
                    </div>
                    <div class="col-6">
                      <b-button variant="primary" @click="vizualizarTermoConfissao">
                        Termo de Confissão
                      </b-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </div>

        <div v-if="seguirParaOpcoesParcelamentoComum">
          <h2 class="title">Selecione abaixo uma das opções de parcelamento</h2>
          <b-card class="mt-3" id="opcoesParcelamento">
            <div v-if="listaOpcoesParcelamento.length > 0">
              <b-alert show variant="warning">
                <b-icon variant="warning" icon="exclamation-triangle-fill" scale="1" />
                O parcelamento fica sujeito à incidência de acréscimos
                moratórios à taxa SELIC, acumulada mensalmente, até o mês
                anterior ao do pagamento e de 1% (um por cento) relativamente ao
                mês em que o pagamento estiver sendo efetuado
              </b-alert>
            </div>
            <div v-else>
              <b-alert show variant="warning">
                <b-icon variant="warning" icon="exclamation-triangle-fill" scale="1" />
                ATENÇÃO : O valor total para pagamento NÃO permite parcelamento
                devido ao valor mínimo exigido para a parcela. Utilize a opção
                PAGAR À VISTA.
              </b-alert>
            </div>
            <div v-if="listaOpcoesParcelamento.length > 0">
              <b-row>
                <b-form-select v-if="listaOpcoesParcelamento.length > 0" v-model="parcelamentoSelecionado"
                  :options="listaOpcoesParcelamento">
                </b-form-select>
              </b-row>
            </div>
            <div class="float-right mt-3 mb-3" v-if="listaOpcoesParcelamento.length > 0">
              <b-col>
                <b-button :disabled="parcelamentoSelecionado == null" @click="
                  $bvModal.show('modal-confirmar-confissao-parelamento')
                  " variant="primary">Confirmar Confissão por Parcelamento</b-button>
              </b-col>
            </div>
          </b-card>
          <b-modal id="modal-confirmar-confissao-parelamento" hide-footer modal-class="small-modal"
            title="Confirma a confissão de débitos?" centered no-close-on-backdrop>
            <p>
              <b-icon icon="exclamation-triangle-fill" scale="1" variant="warning" class="mr-2"></b-icon>
              O método de pagamento selecionado foi o pagamento
              <strong>parcelado</strong>. Após a confirmação, o lançamento
              estará constituído e <strong>não poderá ser alterado</strong>.
            </p>
            <b-button-group class="w-100">
              <b-button variant="outline-secondary" class="mr-3"
                @click="$bvModal.hide('modal-confirmar-confissao-parelamento')">NÃO</b-button>
              <b-button variant="primary" @click="aoConfirmarModalParcelamento">SIM</b-button>
            </b-button-group>
          </b-modal>
        </div>
        <div v-if="seguirParaFinalParcelado">
          <h2 class="title">Emissão de DRAM para Pagamento Parcelado</h2>
          <b-card class="mt-3" id="finalDebitoAutomatico">
            <table class="table table-bordered table-hover" summary="Emissão de DRAM para Pagamento Parcelado">
              <thead>
                <tr>
                  <th>Descrição</th>
                  <th>Número da guia</th>
                  <th>Vencimento</th>
                  <th>Valor total</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Guia de débitos PBH vencimento em
                    {{ guiaEmitida.dataVencimento }}
                  </td>
                  <td>{{ guiaEmitida.numeroGuia }}</td>
                  <td>{{ guiaEmitida.dataVencimento }}</td>
                  <td>{{ formatarMoeda(guiaEmitida.valorTotal) }}</td>
                  <td class="row border-0">
                    <div class="col-6">
                      <b-button v-if="guiaEmitida" variant="primary" @click="emitirDRAM">
                        Emitir DRAM
                      </b-button>
                      <span v-else class="badge bg-danger text-white">DRAM emitida</span>
                    </div>
                    <div class="col-6">
                      <b-button variant="primary" @click="vizualizarTermoConfissao">
                        Termo de Confissão
                      </b-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </div>

        <div v-if="seguirParaOpcoesParcelamentoDebitoAutomatico">
          <h2 class="title">Selecione abaixo uma das opções de parcelamento</h2>
          <b-card class="mt-3" id="opcoesParcelamento">
            <div v-if="listaOpcoesParcelamento.length > 0">
              <b-alert show variant="warning">
                <b-icon variant="warning" icon="exclamation-triangle-fill" scale="1" />
                ATENÇÃO : Para que o débito automático seja efetivado, a
                primeira parcela deverá ser paga na data do vencimento e o
                cadastro deverá ser efetivado junto a uma Instituição
                Financeira. <br />
                Nos termos do art. 7º, § 1º e art. 10, § 1º ambos do Decreto nº
                16.809/2017, o pagamento das parcelas por meio de débito
                automático em conta corrente do devedor será efetivado sob sua
                responsabilidade. A não realização do cadastramento do débito
                automático em conta corrente implicará o cancelamento do
                parcelamento
              </b-alert>
            </div>
            <div v-else>
              <b-alert show variant="warning">
                <b-icon variant="warning" icon="exclamation-triangle-fill" scale="1" />
                ATENÇÃO : O valor total para pagamento NÂO permite parcelamento
                devido ao valor mínimo exigido para a parcela. Utilize a opção
                de PAGAR À VISTA.
              </b-alert>
            </div>
            <div v-if="listaOpcoesParcelamento.length > 0">
              <b-form-select v-model="parcelamentoSelecionado" :options="listaOpcoesParcelamento">
              </b-form-select>
            </div>
            <div class="float-right mt-3 mb-3" v-if="listaOpcoesParcelamento.length > 0">
              <b-col>
                <b-button :disabled="parcelamentoSelecionado == null" @click="
                  $bvModal.show('modal-confirmar-confissao-debito-automatico')
                  " variant="primary">Confirmar Confissão por Parcelamento com DÉBITO
                  AUTOMÁTICO</b-button></b-col>
            </div>
          </b-card>
          <b-modal id="modal-confirmar-confissao-debito-automatico" hide-footer modal-class="small-modal"
            title="Confirma a confissão de débitos?" centered no-close-on-backdrop>
            <p>
              <b-icon icon="exclamation-triangle-fill" scale="1" variant="warning" class="mr-2"></b-icon>
              O método de pagamento selecionado foi o pagamento
              <strong>parcelado com débito automático</strong>. Após a
              confirmação, o lançamento estará constituído e
              <strong>não poderá ser alterado</strong>.
            </p>
            <b-button-group class="w-100">
              <b-button variant="outline-secondary" class="mr-3" @click="
                $bvModal.hide('modal-confirmar-confissao-debito-automatico')
                ">NÃO</b-button>
              <b-button variant="primary" @click="aoConfirmarModalDebitoAutomatico">SIM</b-button>
            </b-button-group>
          </b-modal>
        </div>
        <div v-if="seguirParaFinalDebitoAutomatico">
          <h2 class="title">
            Emissão de DRAM para Pagamento Parcelado com desconto Débito
            Automático
          </h2>
          <b-card class="mt-3" id="finalDebitoAutomatico">
            <table class="table table-bordered table-hover"
              summary="Emissão de DRAM para Pagamento Parcelado com desconto Débito Automático">
              <thead>
                <tr>
                  <th>Descrição</th>
                  <th>Número da guia</th>
                  <th>Vencimento</th>
                  <th>Valor total</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Guia de débitos PBH vencimento em
                    {{ guiaEmitida.dataVencimento }}
                  </td>
                  <td>{{ guiaEmitida.numeroGuia }}</td>
                  <td>{{ guiaEmitida.dataVencimento }}</td>
                  <td>{{ formatarMoeda(guiaEmitida.valorTotal) }}</td>
                  <td class="row border-0">
                    <div class="col-6">
                      <b-button v-if="guiaEmitida" variant="primary" @click="emitirDRAM">
                        Emitir DRAM
                      </b-button>
                      <span v-else class="badge bg-danger text-white">DRAM emitida</span>
                    </div>
                    <div class="col-6">
                      <b-button variant="primary" @click="vizualizarTermoConfissao">
                        Termo de Confissão
                      </b-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </div>

        <b-modal id="modal-confirmar-contribuinte-fora-BH" hide-footer modal-class="small-modal" title="ATENÇÃO:"
          centered no-close-on-backdrop>
          <p>
            <b-icon icon="exclamation-triangle-fill" scale="1" variant="warning" class="mr-2"></b-icon>
            O CNPJ <i>{{ cnpjSelecionado }}</i> <strong>não</strong> está
            inscrito no Cadastro Mobiliário de Contribuintes – CMC de Belo
            Horizonte. Verifique se selecionou o estabelecimento correto do
            contribuinte. Caso queira efetuar a confissão para este mesmo
            estabelecimento, clique em <strong>“Continuar”</strong>. Caso
            contrário, clique em
            <strong>“Pesquisar novamente”</strong>
            e selecione outro CNPJ.
          </p>
          <b-button-group class="w-100 mt-3 mb-3">
            <b-button variant="outline-secondary" class="mr-3"
              @click="$bvModal.hide('modal-confirmar-contribuinte-fora-BH')">Pesquisar novamente</b-button>
            <b-button variant="primary" @click="confirmaSemInscricaoEmBH()">Continuar</b-button>
          </b-button-group>
        </b-modal>

        <b-modal id="modal-detalhe-valores-referencia" ref="modal-detalhe-valores-referencia" size="xl" scrollable
          title="Valores detalhados" centered no-close-on-backdrop>
          <b-table summary="Resumo dos valores totais e forma de pagamento" responsive stacked="md" :bordered="false"
            select-mode="multi" striped hover :small="true" :items="valoresDetalhadosReferencia"
            :fields="cabecalhoDetalheValorReferencia" show-empty
            empty-text="Tente novamente mais tarde. Erro inesperado na rotina de lançamentosSelecionados."
            primary-key="id">
            <template #cell(acoes)>
              <b-button variant="outline-success" @click="$bvModal.show('modal-detalhe-valores-referencia')">Exibir
                detalhe</b-button>
            </template>
          </b-table>
          <template #modal-footer>
            <div class="w-100">
              <p>Resumo</p>
              <b-table summary="Resumo dos valores totais e forma de pagamento" responsive stacked="md"
                :bordered="false" select-mode="multi" striped hover :small="true" :items="valorFormatado"
                :fields="cabecalhoFooter" show-empty
                empty-text="Tente novamente mais tarde. Erro inesperado na rotina de lançamentosSelecionados."
                primary-key="id">
              </b-table>
              <b-button variant="primary" size="sm" class="float-right"
                @click="fecharModal('modal-detalhe-valores-referencia')">
                Sair
              </b-button>
            </div>
          </template>
        </b-modal>
      </form>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
const isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
const isSameOrAfter = require("dayjs/plugin/isSameOrAfter");
import tabelaListagemCNPJ from "../components/compartilhados/tabelaListagemCNPJ.vue";
import botaoTelaInicial from "../components/botaoTelaInicial.vue";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";
import moment from "moment";
import { validarCNPJ } from '@at-siatu-tributario/tipo-identificador';

export default {
  components: {
    loading,
    tabelaListagemCNPJ,
    botaoTelaInicial,
  },
  directives: {
    mask,
  },
  data() {
    return {
      show: false,
      carregando: false,
      mensagemSucesso: [],
      mensagemAcaoFiscalFraude: "",
      mensagemErro: [],
      mensagemISSQNFonte:
        "ISSQN Fonte - Não retido - Atenção: Essa modalidade de parcelamento é restrita às hipóteses de retenção descritas no Art. 21, Lei Municipal nº 8.725/2003",

      issqnSelecionado: null,

      cnpjSelecionado: "",
      razaoSocialSelecionado: "",
      papelCnpjSelecionado: "",
      listaCNPJRelacionado: [],
      valorValido: true,

      CNPJinformado: "",
      mensagemValidacaoCNPJ: "",
      erroValidacaoCNPJ: "",
      preencheCnpjOK: false,
      exibeInformarCNPJ: false,
      logadoGovBr: false,

      forcaLimparCamposListagemCnpj: false,

      impostoDevidoFormatado: "",

      existeCnpjRelacionado: false,

      inscricaoMunicipal: [],
      listaInscricaoMunicipal: [],
      selectAllRows: false,

      mostraTotaisEOpcoesPagamentos: false,
      mostrarListagemCnpj: true,

      contribuinte: {
        cpf: "",
        nome: "",
        inscricaoMunicipal: "",
        idPessoa: "",
        idPessoaPapel: "",
      },
      cnpjRelacionadoFoiSelecionado: false,

      aIdPessoaPapel: "",

      dadosCadastraisConfisao: {
        identificadorInscCnpj: "",
        tipoIdentificador: "",
        codigoNacional: "",
        idPessoaEstabelecimento: "",
        idPessoaPapelEstabelecimento: "",
        idPessoaRepresentante: "",
        cpfRepresentanteLegal: "",
        tipoRepresentanteLegal: "",
        idPessoaPapelRepresentanteLegal: "",
      },

      cnpj: {
        valor: "",
        nome: "",
      },

      referencia: {
        id: 1,
        data: "",
        impostoDevido: "",
        acao: "",
      },

      acaoFiscalEmVigor: {
        selecionado: null,
        minima: "",
        maxima: "",
        idTipoAcaoFiscal: "",
      },
      cabecalhoDetalheValorReferencia: [
        {
          label: "Competência",
          key: "DATA_REFERENCIA",
          formatter: this.formatDateTime,
          class: "text-center",
        },
        {
          label: "ISSQN Simples",
          key: "VALOR_SIMPLES",
          formatter: this.formatCurrency,
          class: "text-right",
        },
        {
          label: "Correção",
          key: "VALOR_CORRECAO",
          formatter: this.formatCurrency,
          class: "text-right",
        },
        {
          label: "Multa à Vista",
          key: "valorMultaAvista",
          class: "text-right font-weight-bold ",
          formatter: this.formatCurrency,
        },
        {
          label: "",
          key: "percentualMultaAvista",
          class: "text-left font-weight-bold ",
          formatter: this.formatPercentual,
        },
        {
          label: "Multa Parcelado com Débito Automático",
          key: "valorMultaDebitoAutomatico",
          class: "text-right font-weight-bold ",
          formatter: (value, item) => {
            return this.formatCurrency(value, item);
          },
        },
        {
          label: "",
          key: "percentualMultaDebitoAutomatico",
          class: "text-left font-weight-bold ",
          formatter: (value, item) => {
            return this.formatPercentual(value, item);
          },
        },
        {
          label: "Multa Parcelado",
          key: "valorMultaParcelado",
          class: "text-right font-weight-bold ",
          formatter: (value, item) => {
            return this.formatCurrency(value, item);
          },
        },
        {
          label: "",
          key: "percentualMultaParcelado",
          class: "text-left font-weight-bold ",
          formatter: this.formatPercentual,
        },
        {
          label: "Juros",
          key: "VALOR_JUROS",
          formatter: this.formatCurrency,
          class: "text-right",
        },
        {
          label: "Selic",
          key: "VALOR_SELIC",
          formatter: this.formatCurrency,
          class: "text-right",
        },
      ],

      cabecalhoResumo: [
        "Valor Total",
        "Valor Total à Vista",
        "Valor Total Parcelado",
        "Valor Total Débito Automático",
      ],
      cabecalhoReferencias: [
        { key: "index", label: "", class: "text-right" },
        {
          key: "data",
          label: "Competência",
          class: "text-right",
          sortable: false,
        },
        { key: "impostoDevido", label: "Imposto Devido", class: "text-right" },
        { key: "acao", label: "Ações", class: "text-center" },
      ],
      listaReferencias: [],
      selecionados: [],
      valoresDetalhadosReferencia: [],

      listaOpcoesParcelamento: [],

      maximoCentavos: 9999999999,
      impostoDevidoCentavos: 0,

      valorAtualizado: [],

      guiaEmitida: {
        dataVencimento: "",
        numeroGuia: "",
        valorTotal: "",
        valorAVisataComDesconto: "",
        valorParceladoComDesconto: "",
        valorParceladoDebitoAutomatico: "",
        urlGuia: "",
        idDenunciaEspontanea: "",
        urlTermoConfissao: "",
      },

      opcaoParcelamentoSelecionada: "",
      opcaoFormaPagamento: "",

      seguirParaSelecaoISSQN: false,

      tiposISSQN: [
        { value: "1442", text: "ISSQN - Próprio" }, // 1442
        { value: "1480", text: "ISSQN - Fonte Retido" }, // 1480
        { value: "1443", text: "ISSQN - Fonte não Retido" }, // 1443
      ],

      // tipoISSQN: "",
      // descTipoISSQN: "",

      cabecalhoSumario: [
        { key: "valorTotal", label: "Valor Total ISSQN Simples" },
        { key: "valorTotalAVista", label: "Valor Total à Vista" },
        {
          key: "valorTotalDebitoAutomatico",
          label: "Valor Total Débito Automático",
          formatter: (value, item) => {
            return this.verificarTributo(value, item);
          },
        },
        {
          key: "valorTotalParcelamento",
          label: "Valor Total Parcelado",
          formatter: (value, item) => {
            return this.verificarTributo(value, item);
          },
        },
        { key: "acoes", label: "Valores detalhados", class: "text-center" },
      ],

      cabecalhoSumarioAVista: [
        { key: "valorTotal", label: "Valor Total ISSQN Simples" },
        { key: "valorTotalAVista", label: "Valor Total à Vista" },
      ],

      cabecalhoFooter: [
        {
          key: "valorTotal",
          label: "Valor Total ISSQN Simples",
          class: "text-right",
        },
        {
          key: "valorTotalAVista",
          label: "Valor Total à Vista",
          class: "text-right",
        },
        {
          key: "valorTotalDebitoAutomatico",
          label: "Valor Total Parcelado com Débito Automático",
          class: "text-right",
          formatter: (value, item) => {
            return this.verificarTributo(value, item);
          },
        },
        {
          key: "valorTotalParcelamento",
          label: "Valor Total Parcelado",
          class: "text-right",
          formatter: (value, item) => {
            return this.verificarTributo(value, item);
          },
        },
      ],

      valorSumario: [
        {
          valorTotal: 0,
          valorTotalAVista: 0,
          valorTotalDebitoAutomatico: 0,
          valorTotalParcelamento: 0,
        },
      ],
      valorFormatado: [
        {
          valorTotal: 0,
          valorTotalAVista: 0,
          valorTotalDebitoAutomatico: 0,
          valorTotalParcelamento: 0,
        },
      ],

      parcelamentoSelecionado: null,

      cnpjsRelacionadosTabela: [],

      acaoFiscal: [],
      possuiAcaoFiscal: "",
      mostrarErroDentroAcaoFiscal: false,
      mostrarErroForaAcaoFiscal: false,
      somaReferenciasMaiorQueMaximo: false,
      exibirNovaConfissao: false,
      seguirParaReferencias: false,
      seguirParaSumario: false,
      seguirParaOpcoesParcelamentoComum: false,
      seguirParaReferenciasESimulacoes: false,
      seguirParaSumarioAVista: false,
      seguirParaOpcoesParcelamentoDebitoAutomatico: false,
      seguirParaFinalDebitoAutomatico: false,
      seguirParaFinalParcelado: false,
      seguirParaFinalAVista: false,
      seguirParafinal: false,
    };
  },
  computed: {
    tipoISSQN() {
      return this.issqnSelecionado?.value || null
    },
    descTipoISSQN() {
      return this.issqnSelecionado?.text || ''
    },

    desabilitarPesquisar() {
      return this.cnpjSelecionado === "";
    },

    validaReferencia() {
      if (this.referencia.data) {
        const anoAtual = new Date().getFullYear();
        const cincoAnosAtras = anoAtual - 5;
        const anoComparacao = dayjs("01/01/" + cincoAnosAtras, "DD/MM/YYYY");

        const [mes, ano] = this.referencia.data.split("/");
        if (typeof ano === "string") if (ano.length < 4) return false;

        // O formato abaixo estava tratando o mes como se fosse dia
        // const dataReferencia = dayjs(`01/${mes}/${ano}`, "DD/MM/YYYY");
        // ${ano}-${mes}-01 = data de referencia no dia 1 do mes
        // T03:01:00.000Z = 03:01 UTC para ajustar o fuso horário
        const dataReferencia = dayjs(`${ano}-${mes}-01T03:01:00.000Z`);

        dayjs.extend(isSameOrBefore);
        dayjs.extend(isSameOrAfter);

        // Se o dia do mês atual for menor ou igual a 8 e a
        // data de referência for do mês anterior, retorna falso
        const mesAnterior = dayjs().subtract(1, "month").date(1).startOf("day");

        if (dayjs().date() <= 8 && dataReferencia.isAfter(mesAnterior)) {
          return false;
        }
        //Não aceitar mês atual ou futuro
        if (
          dataReferencia.isAfter(dayjs()) ||
          dataReferencia.isSame(dayjs(), "month")
        ) {     
          return false;
        }
        const falso = false;
        if (
          this.acaoFiscalEmVigor.minima != "" &&
          this.acaoFiscalEmVigor.maxima != "" &&
          falso
        ) {
          const minima = dayjs(this.acaoFiscalEmVigor.minima, "DD/MM/YYYY");
          const maxima = dayjs(this.acaoFiscalEmVigor.maxima, "DD/MM/YYYY");
    
          return (
            dataReferencia.isSameOrAfter(minima) &&
            dataReferencia.isSameOrBefore(maxima)
          );
        } else {
           
          return (
            dataReferencia.isSameOrAfter(anoComparacao) &&
            dataReferencia.isSameOrBefore(dayjs())
          );
        }
      }

      return false;
    },

    validarImpostoDevido() {
      if (!this.impostoDevidoFormatado) return false;
      // Remove "R$", espaços e pontos de milhar, substitui vírgula por ponto
      const numero = this.impostoDevidoFormatado
        .replace(/\s/g, "") // remove espaços
        // .replace(/[^0-9,]/g, "") // Remover caracteres inválidos, exceto números e vírgula
        .replace("R$", "") // remove "R$"
        .replace(/\./g, "") // remove pontos (milhar)
        .replace(",", "."); // troca vírgula decimal por ponto
      if (numero <= 0) return false;
      // Verifica se o numero e menor que o maximo do NUMBER(13, 2) no banco oracle
      const maximoNumberOracle = 1000000000.0;
      if (numero >= maximoNumberOracle) return false;
      if (this.somaReferenciasMaiorQueMaximo) return false;

      return true;
    },

    mostrarSumario() {
      return (
        this.seguirParaSumario &&
        Object.values(this.valorSumario).every((x) => x !== 0)
      );
    },

    mostrarReferenciaESimulacoes() {
      return this.seguirParaReferenciasESimulacoes && !this.seguirParaSumario;
    },

    ocultarReferenciasESimulacoes() {
      return (
        this.seguirParaSumarioAVista ||
        this.seguirParaOpcoesParcelamentoComum ||
        this.seguirParaOpcoesParcelamentoDebitoAutomatico
      );
    },
    referenciaDuplicada() {
      let igual = 0;
      for (let i = 0; i < this.listaReferencias.length; i++) {
        for (let j = 0; j < this.listaReferencias.length; j++) {
          if (this.listaReferencias[i].data === this.listaReferencias[j].data) {
            igual++;
          }
        }
        if (igual > 1) {
          return true;
        }
        igual = 0;
      }
      return false;
    },
    referenciaAtualDuplicada() {
      for (let i = 0; i < this.listaReferencias.length; i++) {
        if (this.listaReferencias[i].data === this.referencia.data) {
          return true;
        }
      }
      return false;
    },
    stringDataReferencia() {
      dayjs.locale("pt-br");
      // se o dia atual for menor ou igual a 8, a data limite superior é 2 meses atras
      // caso contrário, a data limite superior é o mês anterior
      let dataLimiteSuperior = "";
      if (dayjs().date() <= 8) {
        dataLimiteSuperior = dayjs()
          .subtract(2, "month")
          .format("MMMM [de] YYYY");
      } else {
        dataLimiteSuperior = dayjs()
          .subtract(1, "month")
          .format("MMMM [de] YYYY");
      }
      const dataLimiteInferior = dayjs()
        .subtract(5, "year")
        .startOf("year")
        .format("MMMM [de] YYYY");

      return (
        "A competência deve estar entre " +
        dataLimiteInferior +
        " e " +
        dataLimiteSuperior +
        "."
      );
    },
  },
  async beforeCreate() { },

  async beforeMount() {   
    this.logadoGovBr = this.$store.getters.userInfo.origem === "GovBr";   
    if (this.logadoGovBr) {
      this.contribuinte.cpf = this.$store.getters.userInfo.preferred_username;
      this.contribuinte.nome = this.$store.getters.userInfo.name;
      await this.buscarCNPJRelacionados();
    }
    this.exibeInformarCNPJ = this.$store.getters.userInfo.origem === "AD";
  },

  methods: {
    posicionaPagina() {
      setTimeout(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      }, 500);
    },

    limparCNPJ: function () {
      this.mensagemValidacaoCNPJ = "";
      this.CNPJinformado = "";
      this.cnpj.nome = "";
      this.listaInscricaoMunicipal = [];
      this.preencheCnpjOK = false;
      this.limpar();
    },

    validacaoCNPJ: function () {
      let tamCampo = 0;
      let txt = "";
      let formato = "";
      let tipo = this.CNPJinformado.length;

      this.preencheCnpjOK = false;

      if (tipo <= 18) {
        //CNPJ
        tamCampo = 18;
        txt = "CNPJ";
      }

      if (this.CNPJinformado.length <= tamCampo) {
        this.mensagemValidacaoCNPJ = txt + " digitado está incompleto";
        formato = "text-danger";
        this.preencheCpfdOK = false;
      }
      if (tipo == 18) {
        if (validarCNPJ(this.CNPJinformado)) {
          this.mensagemValidacaoCNPJ = txt + " digitado é válido";
          formato = "text-success";
          this.preencheCnpjOK = true;
        } else {
          this.mensagemValidacaoCNPJ = txt + " - dígito verificador inválido";
          formato = "text-danger";
          this.preencheCnpjOK = false;
        }
      }
      this.erroValidacaoCNPJ = formato;

      if (this.CNPJinformado === "") {
        this.mensagemValidacaoCNPJ = "";
      }
    },

    consisteDataReferencia() {
      if (this.referencia.data) {
        return this.validaReferencia ? "is-valid" : "is-invalid";
      } else return "is-none";
    },

    consisteImpostoDevido() {
      if (
        this.impostoDevidoFormatado &&
        this.impostoDevidoFormatado !== "R$ 0,00"
      ) {
        return this.validarImpostoDevido ? "is-valid" : "is-invalid";
      } else return "is-none";
    },

    SeguirParaFormaPagamento(opcao) {
      this.limparFormasPagamento();
      if (opcao == "AVISTA") {
        this.seguirParaSumarioAVista = true;
        this.opcaoFormaPagamento = "1";
        this.posicionaPagina();
      } else if (opcao == "PARCELAR") {
        this.seguirParaOpcoesParcelamentoComum = true;
        this.opcaoFormaPagamento = "2";
        this.posicionaPagina();
      } else {
        /// DEBITOAUTOMATICO
        this.opcaoFormaPagamento = "3";
        this.seguirParaOpcoesParcelamentoDebitoAutomatico = true;
        this.posicionaPagina();
      }
    },

    limparFormasPagamento() {
      this.parcelamentoSelecionado = null;
      this.seguirParaSumarioAVista = false;
      this.seguirParaOpcoesParcelamentoComum = false;
      this.seguirParaOpcoesParcelamentoDebitoAutomatico = false;
    },

    bloquearExcesso(event) {
      // Permite teclas de controle
      const permitidas = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ];
      if (permitidas.includes(event.key)) return;

      // Permite apenas números
      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault();
        return;
      }

      // Se já está no limite, bloqueia nova digitação
      if (this.impostoDevidoCentavos >= this.maximoCentavos) {
        event.preventDefault();
      }
    },

    formatarValor(event) {
      const permitidas = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ];
      if (permitidas.includes(event.key)) return;

      // Remove tudo que não for dígito
      let apenasNumeros = event.replace(/\D/g, "");

      // Se vazio, define zero
      const valorNumerico = apenasNumeros ? parseInt(apenasNumeros, 10) : 0;

      // Formata como moeda brasileira
      const valorFormatado = (valorNumerico / 100).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      this.impostoDevidoFormatado = valorFormatado;
      this.impostoDevidoNumerico = valorNumerico / 100;
      this.checkMaiorQueMaximo();
    },

    checkMaiorQueMaximo() {
      const maximo = 100000000; // 100 milhões
      this.somaReferenciasMaiorQueMaximo = false;
      let soma = this.impostoDevidoNumerico;
      for (let i = 0; i < this.listaReferencias.length; i++) {
        soma += parseFloat(
          this.listaReferencias[i].impostoDevido
            .replace(/\s/g, "") // remove espaços
            .replace("R$", "") // remove "R$"
            .replace(/\./g, "") // remove pontos (milhar)
            .replace(",", ".") // troca vírgula decimal por ponto
        );
      }
      if (soma > maximo) {
        this.somaReferenciasMaiorQueMaximo = true;
        this.impostoDevidoFormatado = "R$ 0,00";
      } else this.somaReferenciasMaiorQueMaximo = false;
    },

    fecharModal: function (referencia) {
      this.$refs[referencia].hide();
    },

    formatDateTime: function (value) {
      if (!value) return "";
      else return moment(String(value)).format("MM/YYYY");
    },

    formatPercentual: function (value, item) {
      if (value === null || value === undefined) {
        return "%";
      }
      if (this.tipoISSQN == 1480) {
        if (
          item == "percentualMultaParcelado" ||
          item == "percentualMultaDebitoAutomatico"
        )
          return "";
      }
      return value + "%";
    },

    verificarTributo: function (value, item) {
      if (this.tipoISSQN == 1480) {
        if (
          item == "valorTotalParcelamento" ||
          item == "valorTotalDebitoAutomatico"
        )
          return "";
      }
      return value;
    },

    formatCurrency: function (value, item) {
      if (this.tipoISSQN == 1480) {
        if (
          item == "valorMultaParcelado" ||
          item == "valorMultaDebitoAutomatico"
        )
          return "";
      }
      if (value != null) {
        let formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        });
        return formatter.format(value);
      } else {
        return "______";
      }
    },
    goToReemitirGuias() {
      this.$router.push({ name: "USC.21.017" });
    },
    async pesquisar() {
      try {
        this.carregando = true;
        let cnpj = "";
        let cpfResponsavel = "";
        if (this.logadoGovBr) {
          cnpj = this.cnpjSelecionado;
        } else {
          cnpj = this.CNPJinformado.replace(/[^\d\w]+/g, "");

          await this.$axios
            .post(`${this.$env.url_backend}/v1/espontaneo/retorna_CPF_fixo_confissao_Usuario_AD`, {
            })
            .then((response) => {
              const dados = response.data.result;
              if (dados.length > 0) {
                this.contribuinte.cpf = dados[0].CPFFIXOCONFISSAO;  //// CPF fixo do confissao expontanea pelo acesso AD 
              } else {
                this.contribuinte.cpf = "";
              }
            });
          this.exibirNovaConfissao = true;
        }
        cpfResponsavel = this.contribuinte.cpf;
        this.dadosCadastraisConfisao.codigoNacional = cnpj;
        this.dadosCadastraisConfisao.cpfRepresentanteLegal =
          this.contribuinte.cpf;
        const usuario = this.$store.getters.userInfo.origem;

        await this.$axios
          .post(`${this.$env.url_backend}/v1/espontaneo/inscricao-municipal`, {
            cnpj,
            cpfResponsavel,
            usuario,
          })
          .then((response) => {
            this.inscricaoMunicipal = response.data.inscricaoMunicipal;

            if (this.inscricaoMunicipal.length > 0) {
              this.dados = response.data.inscricaoMunicipal;
              this.mostrarListagemCnpj = false;
              this.listaInscricaoMunicipal = this.inscricaoMunicipal.map(
                (x) => {
                  return {
                    value: x.identificador,
                    text: `Inscrição Municipal: ${x.identificador} - ${x.endereco}`.toUpperCase(),
                  };
                }
              );
              this.cnpj = {
                valor: cnpj,
                nome: this.inscricaoMunicipal[0].nome,
              };
              this.posicionaPagina();
            } else {
              //// cnpj  sem inscricao municipal
              this.$bvModal.show("modal-confirmar-contribuinte-fora-BH");
            }
          });
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    async confirmaSemInscricaoEmBH() {
      this.$bvModal.hide("modal-confirmar-contribuinte-fora-BH");
      this.mostrarListagemCnpj = false;
      this.seguirParaSelecaoISSQN = true;
      // busca id pessoa do estabelecimento
      let nomeContribuinte = "";
      let cpfCnpj = "";
      if (this.logadoGovBr) {
        cpfCnpj = this.cnpjSelecionado;
        nomeContribuinte = this.razaoSocialSelecionado;
      } else {
        cpfCnpj = this.CNPJinformado.replace(/[^\d\w]+/g, "");
        const pTipoIdentificador = '4';
        const pIdentificador = cpfCnpj;
        await this.$axios
          .post(`${this.$env.url_backend}/v1/espontaneo/endereco-gov`, {
            pTipoIdentificador,
            pIdentificador
          })
          .then((response) => {
            const dados = response.data.resultado;
            if (dados) {
              nomeContribuinte = dados.RAZAO_SOCIAL;
            } else {
              nomeContribuinte = "";
            }
          });
      }

      this.cnpj.nome = nomeContribuinte;
      this.contribuinte.nome = nomeContribuinte;
      let naturezaPessoa = "2";
      await this.retornaIdPessoa(nomeContribuinte, cpfCnpj, naturezaPessoa);
      // busca id pessoa papel do estabelecimento
      if (this.logadoGovBr)
        this.dadosCadastraisConfisao.identificadorInscCnpj = this.cnpjSelecionado;
      else
        this.dadosCadastraisConfisao.identificadorInscCnpj = this.CNPJinformado.replace(/[^\d\w]+/g, "");
      this.dadosCadastraisConfisao.tipoIdentificador = 4; ////----> CNPJ
      this.dadosCadastraisConfisao.tipoRepresentanteLegal =
        this.papelCnpjSelecionado;
      await this.retornaRazaoSocial(
        this.dadosCadastraisConfisao.idPessoaEstabelecimento
      );
      this.cnpj.valor = this.cnpjSelecionado;

      let pTipoPapel = "";
      let pIdentificador = "";
      let pTipoIdentificador = "";

      pIdentificador = this.dadosCadastraisConfisao.identificadorInscCnpj;
      pTipoIdentificador = this.dadosCadastraisConfisao.tipoIdentificador;
      pTipoPapel = 14; ///  CONTRIBUINTE GERAL
      await this.retornaIdPessoaPapel(
        pIdentificador,
        pTipoIdentificador,
        pTipoPapel,
        this.dadosCadastraisConfisao.idPessoaEstabelecimento
      );
      this.dadosCadastraisConfisao.idPessoaPapelEstabelecimento =
        this.aIdPessoaPapel;
      // nomeContribuinte = this.contribuinte.nome;   //// this.$store.getters.userInfo.given_name + ' ' + this.$store.getters.userInfo.family_name; 
      cpfCnpj = this.contribuinte.cpf; /// --->  Responsavel pela confissao
      naturezaPessoa = "1";
      await this.retornaIdPessoa(nomeContribuinte, cpfCnpj, naturezaPessoa);
      // busca id pessoa papel do responsavel pela confissao
      // if (this.logadoGovBr) {   /// logado GovBR
      pIdentificador = this.dadosCadastraisConfisao.identificadorInscCnpj; /// CNPJ
      pTipoIdentificador = this.dadosCadastraisConfisao.tipoIdentificador; /// 4 ---> CNPJ
      pTipoPapel = 54; ///  REQUERENTE REMISSAO
      await this.retornaIdPessoaPapel(
        pIdentificador,
        pTipoIdentificador,
        pTipoPapel,
        this.dadosCadastraisConfisao.idPessoaRepresentante
      );
      this.dadosCadastraisConfisao.idPessoaPapelRepresentanteLegal =
        this.aIdPessoaPapel;
      // } 
      this.posicionaPagina();
    },

    estaNoIntervalo(dataMMYYYY, inicioPeriodo, fimPeriodo) {
      function toMonthIndex(date) {
        const d = new Date(date);
        return d.getFullYear() * 12 + d.getMonth(); // getMonth é 0-11
      }

      const [mm, yyyy] = dataMMYYYY.split("/").map(Number);
      const ref = yyyy * 12 + (mm - 1); // -1 pois janeiro = 0

      const inicio = toMonthIndex(inicioPeriodo);
      const fim = toMonthIndex(fimPeriodo);

      return ref >= inicio && ref <= fim;
    },

    async adicionaAcaoFiscal() {
      this.mensagemErro = [];
      if (
        this.acaoFiscalEmVigor.idTipoAcaoFiscal == 3 &&
        this.estaNoIntervalo(
          this.referencia.data,
          this.acaoFiscalEmVigor.minima,
          this.acaoFiscalEmVigor.maxima
        )
      ) {
        this.mensagemAcaoFiscalFraude =
          "Não é possível confessar débitos para o período de " +
          this.formatarDataReferencia(this.acaoFiscalEmVigor.minima) +
          "  a " +
          this.formatarDataReferencia(this.acaoFiscalEmVigor.maxima) +
          ".";
        this.mensagemErro.push(this.mensagemAcaoFiscalFraude);
        window.scrollTo(0, 0);
      } else {
        this.referencia.impostoDevido = this.impostoDevidoFormatado;  
        try {
          this.$refs["referencia"].focus();
          this.carregando = true;
          let idPessoaPapel =
            this.dadosCadastraisConfisao.idPessoaPapelEstabelecimento;
          let idPessoa = this.dadosCadastraisConfisao.idPessoaEstabelecimento;
          const referencia = this.referencia.data;
          await this.$axios
            .post(`${this.$env.url_backend}/v1/espontaneo/valida-acao-fiscal`, {
              idPessoaPapel,
              referencia,
              idPessoa,
            })
            .then((response) => {
              if (this.possuiAcaoFiscal === "")
                this.possuiAcaoFiscal = response.data.possuiAcaoFiscal;             
              this.adicionaListaAcaoFiscal(this.possuiAcaoFiscal);
            });
        } catch (error) {
          this.possuiAcaoFiscal = false;
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
        } finally {
          this.carregando = false;
          this.impostoDevidoFormatado = null;
        }
      }
    },

    async buscarCNPJRelacionados() {
      try {
        this.carregando = true;

        await this.$axios
          .get(`${this.$env.url_backend}/v1/espontaneo`)
          .then((response) => {
            const informacoesUsuario = response.data
              ? response.data.informacoesUsuario
              : null;

            this.existeCnpjRelacionado = response.data.cnpjsRelacionados.listaEstabelecimento.length > 0;
            this.contribuinte.idPessoa = informacoesUsuario.ID_PESSOA || null;

            this.cnpjsRelacionadosTabela =
              response.data.cnpjsRelacionados.listaEstabelecimento.map(
                (valor) => {
                  return {
                    cnpj: valor.cnpj,
                    cnpj_limpo: valor.cnpj.replace(/[^\d\w]+/g, ""),
                    nome: valor.nome,
                    selecionado: false,
                  };
                }
              );
          });
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    handleCnpjTabelaSelecionado(values) {
      if (!values || !values.dadosEstabelecimentoSelecionado) {
        return;
      }
      this.cnpjRelacionadoFoiSelecionado = true;
      this.desabilitaIdentificador = true;
      this.cnpjSelecionado =
        values.dadosEstabelecimentoSelecionado.codigoNacional;
      this.razaoSocialSelecionado =
        values.dadosEstabelecimentoSelecionado.razaoSocial;
      this.papelCnpjSelecionado =
        values.dadosEstabelecimentoSelecionado.tipoPapel;

      this.dadosCadastraisConfisao.identificadorInscCnpj =
        values.codigoNacional;
      this.dadosCadastraisConfisao.codigoNacional = values.codigoNacional;
      this.dadosCadastraisConfisao.cpfRepresentanteLegal =
        this.contribuinte.cpf;
      this.dadosCadastraisConfisao.tipoRepresentanteLegal = values.tipoPapel;
      this.dadosCadastraisConfisao.idPessoaPapelRepresentanteLegal = "";
      this.dadosCadastraisConfisao.idPessoaEstabelecimento = "";
    },

    async atualizaReferencia() {
      try {
        this.carregando = true;
        //
        const listaReferenciasNumericas = this.listaReferencias.map((item) => {
          return {
            ...item,
            impostoDevido: item.impostoDevido
              .replace("R$", "") // remove R$
              .replace(/\./g, "") // remove todos os pontos
              .replace(",", ".") // troca vírgula por ponto
              .trim(),
          };
        });
        //
        await this.$axios
          .post(`${this.$env.url_backend}/v1/espontaneo/atualiza-referencias`, {
            listaReferencias: listaReferenciasNumericas,
            idTributo: this.tipoISSQN,
            idPessoaPapel: Number(
              this.dadosCadastraisConfisao.idPessoaPapelEstabelecimento
            ),
          })
          .then((response) => {
            const valoresAtualizados = response.data.resultado;
            this.valorAtualizado = valoresAtualizados;
            this.valoresDetalhadosReferencia = [];
            // atualiza lista com valores atualizados por referencia
            for (let i = 0, l = this.valorAtualizado.length; i < l; i++) {
              let valoresDet = {};
              valoresDet.DATA_REFERENCIA =
                valoresAtualizados[i].DATA_REFERENCIA;
              valoresDet.VALOR_SIMPLES = valoresAtualizados[i].VALOR_SIMPLES;
              valoresDet.VALOR_JUROS = valoresAtualizados[i].VALOR_JUROS;
              valoresDet.VALOR_MULTA = valoresAtualizados[i].VALOR_MULTA;
              valoresDet.percentualMulta =
                valoresAtualizados[i].PERCENTUAL_MULTA;
              valoresDet.VALOR_CORRECAO = valoresAtualizados[i].VALOR_CORRECAO;
              valoresDet.VALOR_SELIC = valoresAtualizados[i].VALOR_SELIC;
              valoresDet.valorTotal =
                valoresAtualizados[i].VALOR_SIMPLES +
                valoresAtualizados[i].VALOR_JUROS +
                valoresAtualizados[i].VALOR_MULTA +
                valoresAtualizados[i].VALOR_CORRECAO +
                valoresAtualizados[i].VALOR_SELIC;
              valoresDet.valorMultaAvista =
                (valoresAtualizados[i].VALOR_SIMPLES +
                  valoresAtualizados[i].VALOR_CORRECAO) *
                valoresAtualizados[i].PERCENTUAL_MULTA || "%";
              valoresDet.valorMultaDebitoAutomatico =
                (valoresAtualizados[i].VALOR_SIMPLES +
                  valoresAtualizados[i].VALOR_CORRECAO) *
                valoresAtualizados[i].PERCENTUAL_MULTA_DEB_AUT;
              valoresDet.valorMultaParcelado =
                (valoresAtualizados[i].VALOR_SIMPLES +
                  valoresAtualizados[i].VALOR_CORRECAO) *
                valoresAtualizados[i].PERCENTUAL_MULTA_PARC;
              valoresDet.percentualMultaAvista =
                valoresAtualizados[i].PERCENTUAL_MULTA * 100;
              valoresDet.percentualMultaDebitoAutomatico =
                valoresAtualizados[i].PERCENTUAL_MULTA_DEB_AUT * 100;
              valoresDet.percentualMultaParcelado =
                valoresAtualizados[i].PERCENTUAL_MULTA_PARC * 100;
              this.valoresDetalhadosReferencia.push(valoresDet);
            }
            ///
            this.valorSumario[0].valorTotal = 0;
            this.valorSumario[0].valorTotalAVista = 0;
            this.valorSumario[0].valorTotalParcelamento = 0;
            this.valorSumario[0].valorTotalDebitoAutomatico = 0;

            for (let item of valoresAtualizados) {
              this.valorSumario[0].valorTotal += Number(item.VALOR_SIMPLES);
              this.valorSumario[0].valorTotalAVista += Number(
                item.VALOR_ATUALIZADO
              );
              this.valorSumario[0].valorTotalParcelamento += Number(
                item.VALOR_DEBITO_PARCELAMENTO
              );
              this.valorSumario[0].valorTotalDebitoAutomatico += Number(
                item.VALOR_DEBITO_AUTOMATICO
              );
            }
            this.valorFormatado = [
              {
                valorTotal: this.formatarMoeda(this.valorSumario[0].valorTotal),
                valorTotalAVista: this.formatarMoeda(
                  this.valorSumario[0].valorTotalAVista
                ),
                valorTotalParcelamento: this.formatarMoeda(
                  this.valorSumario[0].valorTotalParcelamento
                ),
                valorTotalDebitoAutomatico: this.formatarMoeda(
                  this.valorSumario[0].valorTotalDebitoAutomatico
                ),
              },
            ];
            this.seguirParaSumario = true;
            this.mostraTotaisEOpcoesPagamentos = true;
            this.posicionaPagina();
          });
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    async simularOutrasFormasPagamento(valorParcelamento) {
      try {
        this.listaOpcoesParcelamento = [];
        this.carregando = true;
        await this.$axios
          .post(
            `${this.$env.url_backend}/v1/espontaneo/simular-outras-formas-pagamento`,
            {
              valorParcelamento,
            }
          )
          .then((response) => {       
            response.data.resultado.map((opcao) => {
              this.listaOpcoesParcelamento.push({
                text: `Entrada de ${this.formatarMoeda(opcao.AVLRDEPOSITO)} + ${opcao.AQTDPARCELA
                  } parcela(s) de ${this.formatarMoeda(
                    opcao.AVLRPARCELA
                  )} (Total: R$ ${this.formatarMoeda(opcao.AVLRTOTALPARCELAR)})`,
                value: opcao,
                selected: false,
                disabled: false,
                hidden: false,
              });
            });
            // Remove opção de parcelamento com 60 parcelas
            this.listaOpcoesParcelamento = this.listaOpcoesParcelamento.filter(
              (item) => item.value.AQTDPARCELA < 60
            );
            if (this.listaOpcoesParcelamento.length > 0)
              this.listaOpcoesParcelamento.unshift({
                text: "Clique aqui para selecionar uma opção de parcelamento",
                value: null,
                selected: true,
                disabled: true,
                hidden: true,
              });
          });
      } catch (error) {
console.log("error...: : "+error);         
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    voltarParaSimularFormasPagamento() {
      this.parcelamentoSelecionado = null;
      this.seguirParaSumarioAVista = false;
      this.seguirParaOpcoesParcelamentoComum = false;
      this.seguirParaOpcoesParcelamentoDebitoAutomatico = false;
      this.seguirParaReferenciasESimulacoes = true;
      this.posicionaPagina();
      this.seguirParaSumario = false;
    },

    removerReferencia(index) {
      this.listaReferencias.splice(index, 1);
      if (this.listaReferencias.length === 0) {
        this.possuiAcaoFiscal = "";
      }
    },

    simularValores() {
      this.seguirParaReferenciasESimulacoes = true;
      this.posicionaPagina();
      this.seguirParaSumario = false;
    },

    confirmarConfissaoAVista() {
      this.$bvModal.show("modal-confirmar-confissao-a-vista");
    },

    mostrarTabelaReferencias() {
      this.limparFormasPagamento();
      this.seguirParaReferencias = true;
      this.posicionaPagina();
      this.seguirParaSumario = false;
      this.seguirParaReferenciasESimulacoes = false;

      this.mostraTotaisEOpcoesPagamentos = false;
    },

    async aoConfirmarModalAVista() {
      try {
        await this.aoConfirmarModal(true, false);
        this.mostraTotaisEOpcoesPagamentos = false;
        this.seguirParafinal = true;
        this.seguirParaFinalAVista = true;
        this.seguirParaSumarioAVista = false;
        window.scrollTo(0, 0);
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
        this.$bvModal.hide("modal-confirmar-confissao");
      }
    },

    async aoConfirmarModalParcelamento() {
      try {
        await this.aoConfirmarModal(false, false);
        this.mostraTotaisEOpcoesPagamentos = false;
        this.seguirParafinal = true;
        this.seguirParaFinalParcelado = true;
        this.seguirParaOpcoesParcelamentoComum = false;
        window.scrollTo(0, 0);
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
        this.$bvModal.hide("modal-confirmar-confissao");
      }
    },

    async aoConfirmarModalDebitoAutomatico() {
      try {
        await this.aoConfirmarModal(false, true);
        this.mostraTotaisEOpcoesPagamentos = false;
        this.seguirParafinal = true;
        this.seguirParaFinalDebitoAutomatico = true;
        this.seguirParaOpcoesParcelamentoDebitoAutomatico = false;
        window.scrollTo(0, 0);
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
        this.$bvModal.hide("modal-confirmar-confissao");
      }
    },

    async aoConfirmarModal(aVista, debitoAutomatico) {
      this.carregando = true;

      const listaReferencias = [];
      let percent = 0;
      for (let item of this.valorAtualizado) {
        percent =
          this.opcaoFormaPagamento == "1"
            ? item.PERCENTUAL_MULTA
            : this.opcaoFormaPagamento == "2"
              ? item.PERCENTUAL_MULTA_PARC
              : item.PERCENTUAL_MULTA_DEB_AUT;
        listaReferencias.push({
          DATA_REFERENCIA: item.DATA_REFERENCIA, //
          VALOR_IMPOSTO: item.VALOR_IMPOSTO,
          VALOR_SIMPLES: item.VALOR_SIMPLES,
          VALOR_CORRECAO: item.VALOR_CORRECAO,
          VALOR_MULTA: item.VALOR_MULTA,
          VALOR_JUROS: item.VALOR_JUROS,
          VALOR_SELIC: item.VALOR_SELIC,
          VALOR_ATUALIZADO: item.VALOR_ATUALIZADO,
          VALOR_DEBITO_AUTOMATICO: item.VALOR_DEBITO_AUTOMATICO,
          VALOR_DEBITO_PARCELAMENTO: item.VALOR_DEBITO_PARCELAMENTO,
          ID_ATIVIDADE_ECONOMICA: item.ID_ATIVIDADE_ECONOMICA || null,
          FORMA_PAGAMENTO: this.opcaoFormaPagamento,
          PERCENTUAL_MULTA: percent * 100,
          VALOR_TOTAL:
            item.VALOR_SIMPLES +
            item.VALOR_JUROS +
            item.VALOR_MULTA +
            item.VALOR_CORRECAO +
            item.VALOR_SELIC,
        });
      }

      if (!this.logadoGovBr) {   //// -----> logado AD
        this.dadosCadastraisConfisao.tipoIdentificador = 4; ////----> CNPJ
        this.dadosCadastraisConfisao.tipoRepresentanteLegal =
          this.dadosCadastraisConfisao.identificadorInscCnpj;
        await this.retornaRazaoSocial(
          this.dadosCadastraisConfisao.idPessoaEstabelecimento
        );     
        this.cnpj.valor = this.CNPJinformado.replace(/[^\d\w]+/g, "");
        this.dadosCadastraisConfisao.identificadorInscCnpj = this.CNPJinformado.replace(/[^\d\w]+/g, "");
        let pTipoPapel = "";
        let pIdentificador = "";
        let pTipoIdentificador = "";
        let nomeContribuinte = "";
        let cpfCnpj = "";
        let naturezaPessoa = "";
        pIdentificador = this.dadosCadastraisConfisao.identificadorInscCnpj;
        pTipoIdentificador = this.dadosCadastraisConfisao.tipoIdentificador;
        pTipoPapel = 14; ///  CONTRIBUINTE GERAL
        await this.retornaIdPessoaPapel(
          pIdentificador,
          pTipoIdentificador,
          pTipoPapel,
          this.dadosCadastraisConfisao.idPessoaEstabelecimento
        );
        this.dadosCadastraisConfisao.idPessoaPapelEstabelecimento =
          this.aIdPessoaPapel;
        nomeContribuinte = this.cnpj.nome;
        cpfCnpj = this.contribuinte.cpf; /// --->  Responsavel pela confissao
        naturezaPessoa = "1";
        await this.retornaIdPessoa(nomeContribuinte, cpfCnpj, naturezaPessoa);
        // busca id pessoa papel do responsavel pela confissao
        // if (this.logadoGovBr) {   /// logado GovBR
        pIdentificador = this.dadosCadastraisConfisao.identificadorInscCnpj; /// CNPJ
        pTipoIdentificador = this.dadosCadastraisConfisao.tipoIdentificador; /// 4 ---> CNPJ
        pTipoPapel = 54; ///  REQUERENTE REMISSAO
        await this.retornaIdPessoaPapel(
          pIdentificador,
          pTipoIdentificador,
          pTipoPapel,
          this.dadosCadastraisConfisao.idPessoaRepresentante
        );
        this.dadosCadastraisConfisao.idPessoaPapelRepresentanteLegal =
          this.aIdPessoaPapel;
        //
        this.dadosCadastraisConfisao.tipoRepresentanteLegal = 'Funcionário PBH ( ' + this.$store.getters.userInfo.preferred_username + ' )';
      }
       
      const denuncia = {
        idPessoaPapelResponsavel:
          this.dadosCadastraisConfisao.idPessoaPapelRepresentanteLegal || 0,
        idPessoaPapelEstabelecimento:
          this.dadosCadastraisConfisao.idPessoaPapelEstabelecimento,
        idTributo: this.tipoISSQN,
        listaReferencias: listaReferencias,
        indicadorDeDebitoAutomatico: debitoAutomatico ? 1 : 0,
        valorDeposito: aVista
          ? this.valorAtualizado[0].VALOR_ATUALIZADO
          : this.parcelamentoSelecionado.AVLRDEPOSITO,
        valorParcela: aVista ? 0 : this.parcelamentoSelecionado.AVLRPARCELA,
        quantidadeParcelas: aVista
          ? 0
          : this.parcelamentoSelecionado.AQTDPARCELA,
        detalheAcaoFiscal: this.valorAtualizado[0].acaoFiscal,
        tipoPapelResponsavel:
          this.dadosCadastraisConfisao.tipoRepresentanteLegal,
        cpfResponsavel: this.dadosCadastraisConfisao.cpfRepresentanteLegal,
        identificador: this.dadosCadastraisConfisao.identificadorInscCnpj,
        tipoIdentificador: this.dadosCadastraisConfisao.tipoIdentificador,
        idPessoaContribuinte:
          this.dadosCadastraisConfisao.idPessoaEstabelecimento,
        idPessoaResponsavel: this.dadosCadastraisConfisao.idPessoaRepresentante,
        possuiAcaoFiscal: this.possuiAcaoFiscal,
        idTipoAcaoFiscal: this.acaoFiscalEmVigor.idTipoAcaoFiscal,
      };
      try {
        await this.$axios
          .post(`${this.$env.url_backend}/v1/espontaneo/inclui-acao-fiscal`, {
            denuncia,
          })
          .then((response) => {
            this.guiaEmitida.urlGuia = response.data.resultado.GUIA.URLEMISSAO;
            this.guiaEmitida.dataVencimento = this.formatarData(
              new Date(response.data.resultado.GUIA.DATAVENCIMENTO)
            );
            this.guiaEmitida.numeroGuia =
              response.data.resultado.GUIA.NUMEROGUIA;
            this.guiaEmitida.valorTotal =
              response.data.resultado.GUIA.VALORTOTAL;
            this.guiaEmitida.valorAVisataComDesconto =
              response.data.resultado.GUIA.VALORDESCONTO;
            this.guiaEmitida.valorParceladoComDesconto =
              response.data.resultado.GUIA.VALORDESCONTO;
            this.guiaEmitida.valorParceladoDebitoAutomatico =
              response.data.resultado.GUIA.VALORDESCONTO;
            this.guiaEmitida.idDenunciaEspontanea =
              response.data.idDenunciaEspontanea;
            this.guiaEmitida.urlTermoConfissao =
              this.$env.url_cobranca +
              "/emissor/termo_confissao_denuncia_esp?id=" +
              response.data.argumentoURL;
            this.mensagemSucesso.push(response.data.mensagem);
          });
        window.open(this.guiaEmitida.urlTermoConfissao, "_blank");
      } catch (error) {
        const mensagem =
          "Denúncia não incluída - Estamos com uma instabilidade momentânea nos serviços. Nossa equipe já está cuidando disso. Por favor, tente novamente em breve.";
        this.mensagemErro.push(mensagem);
        console.error("Erro ao emitir confissão", error);
        this.$bvModal.hide("modal-confirmar-confissao");
        window.scrollTo(0, 0);
        // throw error;
      } finally {
        this.carregando = false;
        this.$bvModal.hide("modal-confirmar-confissao");
      }
    },

    emitirDRAM() {
      window.open(this.guiaEmitida.urlGuia, "_blank");
    },

    vizualizarTermoConfissao() {
      window.open(this.guiaEmitida.urlTermoConfissao, "_blank");
    },

    adicionaListaAcaoFiscal(acaoFiscal) { 
      // Remove espaços e divide em mês e ano
      const partes = this.referencia.data.trim().split("/");
      const [mesStr, anoStr] = partes;
      const mes = parseInt(mesStr, 10);
      const ano = parseInt(anoStr, 10);
      // Cria a data no horário local
      const dataConv = new Date(ano, mes - 1, 1, 0, 0, 0); // dia 1, hora 00:00 local    
      const dataReferencia = dayjs(dataConv, "DD/MM/YYYY");

      const inicioAcaoFiscal = dayjs(
        this.acaoFiscalEmVigor.minima,
        "DD/MM/YYYY"
      );

      const fimAcaoFiscal = dayjs(this.acaoFiscalEmVigor.maxima, "DD/MM/YYYY");
      const dentroDoPeriodo =
        dataReferencia.isSameOrAfter(inicioAcaoFiscal) &&
          dataReferencia.isSameOrBefore(fimAcaoFiscal)
          ? true
          : false;

      if (
        this.possuiAcaoFiscal === "" ||
        (this.possuiAcaoFiscal && dentroDoPeriodo) ||
        (!this.possuiAcaoFiscal && !dentroDoPeriodo)
      ) {
        this.listaReferencias.push({
          id: this.referencia.id,
          data: this.referencia.data,
          impostoDevido: this.referencia.impostoDevido,
          acaoFiscal: acaoFiscal
            ? "Possui Ação Fiscal"
            : "Não possui Ação Fiscal",
          actions: [],
        });
        this.mostrarErroForaAcaoFiscal = false;
        this.mostrarErroDentroAcaoFiscal = false;
      } else if (this.possuiAcaoFiscal && !dentroDoPeriodo) {
        this.mostrarErroForaAcaoFiscal = true;
      } else if (!this.possuiAcaoFiscal && dentroDoPeriodo) {
        this.mostrarErroDentroAcaoFiscal = true;
      } else {
        console.log("Erro");
      }
      this.limparReferencia();
    },
    limparValoresReferencias() {
      this.referencia.data = "";
      this.impostoDevidoFormatado = "";
    },

    limparReferencia() {
      let ultimoIndice = this.listaReferencias.at(-1);

      this.referencia = {
        id: ultimoIndice.id + 1,
        data: "",
        impostoDevido: "",
      };
    },

    retornaTotal() {
      return this.listaReferencias
        .reduce((acumulador, item) => {
          return (
            acumulador +
            Number(
              item.impostoDevido
                .replace(/\s/g, "") // remove espaços
                .replace("R$", "") // remove "R$"
                .replace(/\./g, "") // remove pontos (milhar)
                .replace(",", ".") // troca vírgula decimal por ponto
            )
          );
        }, 0)
        .toString();
    },

    seguirParaConfissao() {
      this.exibirNovaConfissao = true;
      this.mensagemErro = [];
      if (!this.existeCnpjRelacionado && this.logadoGovBr ){
          const mens =  "Não foi encontrado CNPJ relacionado para este CPF.";
          this.mensagemErro.push(mens);
          window.scrollTo(0, 0);            
      } else {
           this.posicionaPagina();
      }      
    },

    adicionarDias(dataStr, dias) {
      // Quebra a data em partes
      const [dia, mes, ano] = dataStr.split("/").map(Number);

      // Cria um objeto Date (mês em JS começa em 0)
      const data = new Date(ano, mes - 1, dia);

      // Soma os dias
      data.setDate(data.getDate() + dias);

      // Formata novamente em dd/mm/yyyy
      const diaFormatado = String(data.getDate()).padStart(2, "0");
      const mesFormatado = String(data.getMonth() + 1).padStart(2, "0");
      const anoFormatado = data.getFullYear();

      return `${diaFormatado}/${mesFormatado}/${anoFormatado}`;
    },

    async seguirSelecaoISSQN() {
      ///  busca os dados da inscrição selecionada no array this.inscricaoMunicipal
      const resultado = this.inscricaoMunicipal.find(
        (item) => item.identificador === this.contribuinte.inscricaoMunicipal
      );
      /// busca dados da inscricao selecionada
      this.dadosCadastraisConfisao.identificadorInscCnpj =
        resultado.inscricaoMunicipal;
      this.dadosCadastraisConfisao.tipoIdentificador = 1; ////----> INSCRICAO MUNICIPAL
      this.dadosCadastraisConfisao.idPessoaPapelEstabelecimento =
        resultado.idPessoaPapel;
      this.dadosCadastraisConfisao.idPessoaEstabelecimento = resultado.idPessoa;
      this.dadosCadastraisConfisao.tipoRepresentanteLegal = resultado.tipoPapel;
      this.dadosCadastraisConfisao.idPessoaPapelRepresentanteLegal =
        resultado.idPessoaPapelResponsavel;
      ///  atraves do idPessoaPapel da is=nscricao selecionada verifica se tem acao fiscal no periodo
      const idPessoaPapelSelecionado = resultado.idPessoaPapel;

      await this.$axios
        .post(`${this.$env.url_backend}/v1/espontaneo/verifica-acoes-fiscais`, {
          idPessoaPapel: idPessoaPapelSelecionado,
        })
        .then((response) => {
          this.acaoFiscal = response.data.resultado || [];
          // define valor padrão para corrigir erro de campo vazio
          if (!this.acaoFiscal || this.acaoFiscal.length === 0) {
            this.acaoFiscal.push({
              DATA_INICIO_PERIODO: "",
              DATA_FIM_PERIODO: "",
            });
          }
          this.acaoFiscalEmVigor.minima =
            this.acaoFiscal[0].DATA_INICIO_PERIODO || "";
          this.acaoFiscalEmVigor.maxima =
            this.acaoFiscal[0].DATA_FIM_PERIODO || "";
          this.acaoFiscalEmVigor.idTipoAcaoFiscal =
            this.acaoFiscal[0].ID_TIPO_ACAO_FISCAL;          
        });
      /////  Wagner
      this.carregando = false;
      this.seguirParaSelecaoISSQN = !this.seguirParaSelecaoISSQN;
      this.posicionaPagina();
    },

    async retornaIdPessoa(nomeContribuinte, cpfCnpj, naturezaPessoa) {
      try {
        this.carregando = true;
        const body = {
          nomeContribuinte: nomeContribuinte,
          cpfCnpj: cpfCnpj,
          naturezaPessoa: naturezaPessoa,
        };
        await this.$axios
          .post(
            `${this.$env.url_backend}/v1/espontaneo/retorna-id-pessoa`,
            body
          )
          .then((response) => {
            const retorno = response.data;
            if (naturezaPessoa == 2)
              /// pessoa juridica
              this.dadosCadastraisConfisao.idPessoaEstabelecimento =
                retorno.idPessoa;
            /// pessoa fisica
            else
              this.dadosCadastraisConfisao.idPessoaRepresentante =
                retorno.idPessoa;
          });
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        window.scrollTo(0, 0);
        throw new Error(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    async retornaRazaoSocial(idPessoa) {
      try {
        this.carregando = true;
        const body = {
          idPessoa: idPessoa,
        };
        await this.$axios
          .post(
            `${this.$env.url_backend}/v1/espontaneo/retorna-razao-social`,
            body
          )
          .then((response) => {
            const retorno = response.data;
            this.cnpj.nome = retorno.razaoSocial;
          });
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        window.scrollTo(0, 0);
        throw new Error(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    async retornaIdPessoaPapel(
      identificador,
      tipoIdentificador,
      idTipoPapel,
      idPessoa
    ) {
      try {
        this.carregando = true;
        const body = {
          identificador: identificador,
          tipoIdentificador: tipoIdentificador,
          idTipoPapel: idTipoPapel,
          idPessoa: idPessoa,
        };
        await this.$axios
          .post(
            `${this.$env.url_backend}/v1/espontaneo/retorna-id-pessoa-papel`,
            body
          )
          .then((response) => {
            const retorno = response.data;
            this.aIdPessoaPapel = retorno.idPessoaPapel;
          });
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        window.scrollTo(0, 0);
        throw new Error(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    async limpar() {
      this.limparValoresReferencias();
      this.somaReferenciasMaiorQueMaximo = false;
      this.mostrarListagemCnpj = true;
      this.mostraTotaisEOpcoesPagamentos = false;
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      this.forcaLimparCamposListagemCnpj = !this.forcaLimparCamposListagemCnpj;

      this.inscricaoMunicipal = {};
      this.listaInscricaoMunicipal = [];
      this.contribuinte.inscricaoMunicipal = "";
      this.listaReferencias = [];
      this.referencia = {
        id: 1,
        data: "",
        impostoDevido: "",
        acao: "",
      };

      this.cnpj = {
        valor: "",
        nome: "",
      };

      this.cnpjRelacionadoFoiSelecionado = false;

      this.possuiAcaoFiscal = "";

      this.cnpjSelecionado = "";
      this.issqnSelecionado = "";
      this.mostrarErroDentroAcaoFiscal = false;
      this.mostrarErroForaAcaoFiscal = false;

      this.exibirNovaConfissao = true;
      this.seguirParaSelecaoISSQN = false;
      this.seguirParaReferencias = false;
      this.seguirParaSumario = false;
      this.seguirParaOpcoesParcelamentoComum = false;
      this.seguirParaReferenciasESimulacoes = false;
      this.seguirParaSumarioAVista = false;
      this.seguirParaOpcoesParcelamentoDebitoAutomatico = false;
      this.seguirParaFinalDebitoAutomatico = false;
      this.seguirParaFinalParcelado = false;
      this.seguirParaFinalAVista = false;
      this.seguirParafinal = false;
      this.parcelamentoSelecionado = null;
      this.acaoFiscalEmVigor = {
        selecionado: null,
        minima: "",
        maxima: "",
      };
    },

    formatarData(valor) {
      const data = new Date(valor);

      const dia = String(data.getUTCDate()).padStart(2, "0");
      const mes = String(data.getUTCMonth() + 1).padStart(2, "0"); // meses começam em 0
      const ano = data.getUTCFullYear();

      return `${dia}/${mes}/${ano}`;
    },

    formatarDataReferencia(valor) {
      return dayjs(valor).format("DD/MM/YYYY");
    },

    formatarMoeda(valor) {
      if (valor != null) {
        let formatador = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        });

        return formatador.format(valor);
      }
    },

    formatarNumero(valor) {
      if (valor != null) {
        let formatador = new Intl.NumberFormat("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 2,
        });

        return formatador.format(valor);
      }
    },
  },
};
</script>


<style></style>
